import React, { MouseEventHandler } from "react";

import styles from "./AnswerInput.module.scss";
import block from 'bem-css-modules';
import {Answer, AnswerData} from "../InputFields.types";

import { sanitizeContent as s } from "../../../../util/functions";

const AnswerInput = (props: { buttonData: AnswerData, onAnswerCLick: (answer: Answer) => void, stepLabel: string }) => {
  const {
    buttonData: {
      text,
      crmFieldValue,
      nextStepAnswer,
    },
    onAnswerCLick,
    stepLabel
  } = props;

  const b = block(styles);

  const formattedAnswer = {
    text: text,
    field_value: crmFieldValue,
    next_step_answer: nextStepAnswer
  }

  const onCLickAnswerInput: MouseEventHandler<HTMLButtonElement> = () => {
    setTimeout(() => {
      onAnswerCLick(formattedAnswer);
    }, 200);
  }

  return (
    <div className={b()} >
      <button className={`${b("button")} event-tracking-step--${stepLabel}`} onClick={onCLickAnswerInput}>
        <span dangerouslySetInnerHTML={{ __html: s(text) }} />
      </button>
    </div>
  )
}

export default AnswerInput;